import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { CapTableScanBanner } from '../cap-table-scan-banner/index';
import Header from '../header/index';

interface HeaderLayoutProps {
  children: ReactNode;
  className?: string;
}

const HeaderLayout: FC<HeaderLayoutProps> = ({ children, className }) => {
  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-y-auto bg-gray-50 lg:pb-4 lg:pr-6">
      <CapTableScanBanner />
      <Header />
      <div className="h-full w-full overflow-y-auto max-lg:px-4" id="mobile-scrollbar-target">
        <div
          className={twMerge(
            'flex h-fit w-full justify-between gap-4 overflow-y-auto bg-white p-4 shadow-sm max-lg:mb-4 max-lg:mt-[1px] max-lg:rounded-md max-xs:rounded-b-[6px] max-xs:rounded-t-[6px] max-xs:shadow-sm lg:h-full lg:rounded-t-[24px] lg:shadow-none',
            className,
          )}
          id="scrollbar-target"
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default HeaderLayout;
